import React from 'react';
import { Typography, Image, Row, Col, Divider } from 'antd';
import { styles } from '../../../styles';
import RelatedBlog from './RelatedBlogs';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../../hooks/MediaQuery.hook';
import { DEFAULT_LEAGUE_LINK } from '../../../utils/constant';
import BlogFooter from '../../../components/BlogFooter';

const { Title, Paragraph } = Typography;

export default function Blog2() {
  const matches = useMediaQuery('(min-width: 768px)');

  return (
    <>
    <Row style={styles.navLinks}>        
      <p><Link to={'/'}>Home</Link> / <Link to={'/blogs'}>Blogs </Link>/ The rise of Calafiori at Arsenal<span></span></p>
    </Row>
    <Row justify="center">
      <Col xs={24} sm={22} md={20} lg={16}>
        <div
        style={styles.blogContainer}
        >
          <Typography>
            <Title level={2} style={{...styles.mainHeading, fontSize: !matches ? '24px': ''}}>
              The rise of Calafiori at <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal</a>
            </Title>
            <Paragraph style={styles.blogParagraph}>
            <a target='_blank' rel="noreferrer" href="https://www.transfermarkt.com/riccardo-calafiori/profil/spieler/502821">Riccardo Calafiori</a> is making waves at Arsenal, having joined from Bologna in a move that strengthens the club’s defense. The Italian defender is eager to make a significant impact in the Premier League, thriving under the pressure of high expectations. Ricardo Calafiori’s impact at Arsenal, following his move to North London, has been both promising and crucial in adding depth and quality to Mikel Arteta’s squad. 
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            The young Italian left-back, signed to provide competition and cover for <a target='_blank' rel="noreferrer" href="https://www.transfermarkt.com/kieran-tierney/profil/spieler/300716">Kieran Tierney</a> and Oleksandr Zinchenko, has quickly shown why <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal</a> sought his services. His performances so far have reflected his potential to become a key player for the Gunners in the long term. 
            </Paragraph>

          <Image
            preview={false}
              src="https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/Calafiori.webp" // Replace with a relevant image URL
              alt="Calafiori and Arsenal"
              style={{ borderRadius: '8px', width: '75%', margin: '10px' }}
            />

            <Title level={4} style={styles.blogHeading}>Calafiori’s Role at Arsenal</Title>
            <Paragraph style={styles.blogParagraph}>
            Riccardo Calafiori has quickly adapted to life at <a href="https://koostream.live/fixtures/team/Arsenal">Arsenal</a>, expressing his satisfaction and ambition. The young defender’s versatility and ability to perform under pressure were key factors in Arsenal’s decision to sign him.
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            His outstanding performances at <a target='_blank' rel="noreferrer" href="https://www.uefa.com/euro2024/">Euro 2024</a> not only increased his market value but also solidified his reputation as a promising talent. Unlike Tierney and zinchenko he can play both as inverted fullback and a tradional full back. Although calafiori is a great defender that’s not all that he has to offer to the team, he has helped bring the best out in martenelli,Martenelli has scored 3 goals and assisted 2 goals in 5 matches. Calafiori has featured in all of those 5 games.             
            </Paragraph>

            <Paragraph style={styles.blogParagraph}>
            His presence has prevented martenelli to drop back in comparism to when he played in front zinchenko or Tierney.This because calafiori is defensively very sound and losses the ball much less than the latter.
            </Paragraph>

            <Title level={4} style={styles.blogHeading}>Fitting into Arteta’s defence</Title>
            <Paragraph style={styles.blogParagraph}>
            Arsenal already had depth at left-back. Signing Calafiori was about raising the ceiling, not filling a vacancy. Competition with Oleksandr Zinchenko’s inverted style is the point. A <Link to={DEFAULT_LEAGUE_LINK}>Premier League</Link> title race rewards squads that can change shape without dropping quality.
            </Paragraph>
            <Paragraph style={styles.blogParagraph}>
            None of this makes him an automatic starter every week. It does make him a useful case study in how modern full-backs are recruited: athleticism, passing under pressure, and the ability to play in more than one structure.
            </Paragraph>

            <Title level={4} style={styles.blogHeading}>Conclusion</Title>
            <Paragraph style={styles.blogParagraph}>
            Calafiori’s rise at Arsenal is still a work in progress. The transfer made sense on paper; the test is whether he stays healthy and whether Arteta trusts him in the biggest fixtures. For now he is a reminder that defensive recruitment is as much about tactical fit as it is about reputation.
            </Paragraph>

            <Divider></Divider>

            <Title level={4} style={{...styles.blogHeading, textAlign: 'start', fontSize: '18px' }}>
              Read More Below
            </Title>
            <div style={{paddingRight: '10px'}}>
              <RelatedBlog excludedId={2}></RelatedBlog>
            </div>
            <BlogFooter />
          </Typography>
        </div>
      </Col>
    </Row>
    </>
  );
}

